import firebase from "@/firebase/firebase"
import "firebase/auth";
import {db} from "@/firebase/db"
import store from '@/store'
import router from '@/router'
import crypto from 'crypto'

const md5hex = str => crypto.createHash('md5').update(str, 'binary').digest('hex')

const guestUser = {
  name: "Guest",
  authenticated: false,
};

store.commit('setUser', guestUser);

firebase.auth().onAuthStateChanged(async user => {
  //console.log("onAuthStateChanged")
  let currentUser = guestUser
  let firstLogin = false

  if (user) {
    currentUser = {
      authenticated: true,
      uid: user.uid,
      name: user.displayName || "user",
      photoURL: user.photoURL,
    }

    // Get user profile from db
    const docRef = db.collection("users").doc(user.uid)
    const doc = await docRef.get()

    if (doc.exists) {
      currentUser = {...currentUser, ...doc.data()}
    } else {
      // Add user if not exist
      await db.runTransaction(async tx => {
        // Generate username if empty or already exists
        let unameDoc = await db.collection("usernames").doc(currentUser.name).get()
        if (unameDoc.exists) {
          currentUser.name += md5hex(user.email).substring(0,6)
        }
        unameDoc = await db.collection("usernames").doc(currentUser.name).get()
        if (unameDoc.exists) {
          currentUser.name = user.uid;
        }
        // Generate photoURL
        if (!currentUser.photoURL && user.email) {
          currentUser.photoURL = `https://avatars.dicebear.com/api/identicon/${md5hex(user.email)}.svg?b=%23fff&m=15`
        }
        // Save
        await Promise.all([
          tx.set(docRef, { name: currentUser.name, photoURL: currentUser.photoURL }),
          tx.set(db.collection("usernames").doc(currentUser.name), { user: user.uid }),
        ])
      })

      firstLogin = true
    }
  }

  //console.log("currentUser: ", currentUser)
  store.commit('setUser', currentUser)

  if (firstLogin) router.replace('/account')
});
